import React, { useState, useEffect, useRef } from "react";
import { useNavigate } from "react-router-dom";
import EditIcon from '@mui/icons-material/Edit';
import DeleteIcon from '@mui/icons-material/Delete';
import { TextField, InputAdornment, Box } from '@mui/material';
import SearchIcon from '@mui/icons-material/Search';
import {
  TableContainer,
  Table,
  TableHead,
  TableBody,
  TableRow,
  TableCell,
  Paper,
  Button,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
} from '@mui/material';

const drawerWidth = 240;

function Topics() {
  const [searchTerm, setSearchTerm] = useState('');
  const [showAddTopicCard, setShowAddTopicCard] = useState(false);
  const [showMasterPage, setShowMasterPage] = useState(false); 
  const [selectedClass, setSelectedClass] = useState('');
  const [selectedSubject, setSelectedSubject] = useState('');
  const [videoLink, setVideoLink] = useState('');
  const [topicHeading, setTopicHeading] = useState('');
  const [topicContent, setTopicContent] = useState('');
  const [topicPath, setTopicPath] = useState(null);
  const [error, setError] = useState('');
  const [topics, setTopics] = useState([]);
  const [openDialog, setOpenDialog] = useState(false); // State for dialog
  const [topicToDelete, setTopicToDelete] = useState(null); // Store topicId to delete

  let navigate = useNavigate();

  const handleAddTopicClick = () => {
    navigate('/addtopic') 
  };

  const fetchClasses = async () => {
    try {
      const response = await fetch('https://wsmsv1.aidigitalsec.com/api/Teacher_Topic/GetTopic_Teacher', {
        method: 'POST',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
        body: JSON.stringify({
          teacherId: sessionStorage.getItem('employeeId'),
          classId: selectedClass, // Optionally include classId if filtering 
          subjectId: selectedSubject, // Optionally include subjectId if filtering 
        }),
      });
      const data = await response.json();
      console.log("Topics API response:", data); // ✅ Check what you actually get

      if (Array.isArray(data)) {
        setTopics(data);
      } else if (data && Array.isArray(data.topics)) {
        setTopics(data.topics);
      } else {
        setTopics([]); // fallback so .map never breaks
      }
    } catch (error) {
      console.error('Error fetching classes:', error);
    }
  };

  useEffect(() => {
    fetchClasses();
  }, []);

  const handleEdit = (topicId) => {
    navigate(`/edittopic/${topicId}`)
  };

  const handleDelete = async (topicId) => {
    try {
      const response = await fetch(`https://wsmsv1.aidigitalsec.com/api/Teacher_Topic/Id?TopicId=${topicId}`, {
        method: 'DELETE',
        headers: {
          'Content-Type': 'application/json',
          Authorization: sessionStorage.getItem('token'),
        },
      });

      if (response.ok) {
        setTopics(topics.filter(topics => topics.topicId !== topicId));
      } else {
        setError('Failed to delete topic.');
      }
    } catch (error) {
      console.error('Error deleting topic:', error);
      setError('Error deleting topic.');
    }
  };

  const handleOpenDialog = (topicId) => {
    setTopicToDelete(topicId); // Store the topicId to delete
    setOpenDialog(true); // Open the dialog
  };

  const handleDialogClose = () => {
    setOpenDialog(false); // Close the dialog
    setTopicToDelete(null); // Clear the topicId
  };

  const handleConfirmDelete = () => {
    if (topicToDelete) {
      handleDelete(topicToDelete); // Call the delete function
    }
    handleDialogClose(); // Close the dialog
  };
// 🔴 CHANGE 1: SEARCH FILTER LOGIC ADD 
  const filteredTopics = topics.filter((topic) => {
    const search = searchTerm.toLowerCase();

    return (
      topic.topic?.toLowerCase().includes(search) ||
      topic.subjectName?.toLowerCase().includes(search) ||
      topic.lessionName?.toLowerCase().includes(search) ||
      topic.className?.toString().includes(search)
    );
  });
  return (
    <Box component="main" sx={{
      width: { md: `calc(100% - ${drawerWidth}px)` },
      ml: { md: `${drawerWidth}px` },
      mt: { xs: 0, sm: '74px' },
      p: { xs: 1, md: 3 },
    }}>
      <div className="topics-wrapper">
        {!showMasterPage && (
          <>
            <div className="topics-header">
              <div className="topics-search-container">
                <TextField
                  placeholder="Search Topics..."
                  value={searchTerm}
                  onChange={(e) => setSearchTerm(e.target.value)}
                  sx={{
                    width: '350px',
                    backgroundColor: 'white',
                    '& .MuiInputBase-root': {  // target input container
                      height: '40px',
                    },
                    '& input': {  // target the actual input
                      height: '40px',
                      padding: '0 0 0 35px', // leave space for icon
                    },
                  }}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <SearchIcon />
                      </InputAdornment>
                    ),
                  }}
                />
               <Button
  onClick={handleAddTopicClick}
  variant="contained"
  sx={{
    width: '250px',
    textAlign: 'center',
    backgroundColor: '#063552',   // 🟠 navbar orange
    color: '#ffffff',
    position: 'absolute',
    right: '55px',
    fontWeight: 600,
    textTransform: 'none',        // First letter capital
    '&:hover': {
      backgroundColor: '#063552', // darker orange hover
    },
  }}
>
  Add Topic
</Button>

              </div>
            </div>
            <div className="topics-table">
              <TableContainer component={Paper} sx={{ maxWidth: '100%', overflowX: 'auto', marginTop: '20px' }}>
                <Table sx={{ tableLayout: 'fixed', width: '100%' }}>
                  <TableHead >
                    <TableRow>
                      <TableCell sx={{ width: '6%', minWidth: 40, width:'200px', fontSize: '1.1rem', fontWeight: 'bold', color:'white' }}>
                        Class Name
                      </TableCell>
                      <TableCell sx={{ width: '18.5%', minWidth: 150, width:'200px', fontSize: '1.1rem', fontWeight: 'bold', color:'white' }}>
                        Topic Name
                      </TableCell>
                      <TableCell sx={{ width: '18.5%', minWidth: 150, width:'200px', fontSize: '1.1rem', fontWeight: 'bold', color:'white' }}>
                        Subject Name
                      </TableCell>
                      <TableCell sx={{ width: '18.5%', minWidth: 150, width:'200px', fontSize: '1.1rem', fontWeight: 'bold', color:'white' }}>
                        Lesson Name
                      </TableCell>
                      <TableCell sx={{ width: '36%', minWidth: 150, width:'300px', maxWidth: 350, fontSize: '1.1rem', fontWeight: 'bold', color:'white' }}>
                        Action
                      </TableCell>
                    </TableRow>
                  </TableHead>
                  <TableBody>
                 {/*  {Array.isArray(topics) && topics.length === 0 ? ( */}
                  {filteredTopics.length === 0 ?(         // code edited

                      <TableRow>
                        <TableCell
                          colSpan={5}
                          sx={{ textAlign: 'center', padding: '12px', fontSize: '1rem', color: '#777' }}
                        >
                          No Topics Available
                        </TableCell>
                      </TableRow>
                    ) : (
               //       topics.map((topic) => (
                    filteredTopics.map((topic) => (     //code edited

                    <TableRow key={topic.topicId}>
                          <TableCell sx={{ width: '6%', minWidth: 40, width:'60px', maxWidth: 80, fontSize: '1rem' }}>
                            {topic.className}
                          </TableCell>
                          <TableCell sx={{ width: '18.5%', minWidth: 150, width:'200px', fontSize: '1rem' }}>
                            {topic.topic}
                          </TableCell>
                          <TableCell sx={{ width: '18.5%', minWidth: 150, width:'200px', fontSize: '1rem' }}>
                            {topic.subjectName}
                          </TableCell>
                          <TableCell sx={{ width: '18.5%', minWidth: 150, width:'200px', fontSize: '1rem' }}>
                            {topic.lessionName}
                          </TableCell>
                          <TableCell sx={{ width: '30%', minWidth: 150, width:'350px', maxWidth: 350, fontSize: '1rem' }}>
                            <Button
                              variant="contained"
                              color="primary"
                              onClick={() => handleEdit(topic.topicId)}
                              sx={{ width: '100px', marginRight: '10px', bgcolor: '#198a46ff', '&:hover': { bgcolor: 'teal' } }}
                            >
                              <EditIcon />
                              Edit
                            </Button>
                            <Button
                              variant="contained"
                              color="error"
                              onClick={() => handleOpenDialog(topic.topicId)}
                              sx={{ width: '120px' }}
                            >
                              <DeleteIcon />
                              Delete
                            </Button>
                          </TableCell>
                        </TableRow>
                      ))
                    )}
                  </TableBody>
                </Table>
              </TableContainer>
            </div>
            {/* Dialog for delete confirmation */}
            <Dialog open={openDialog} onClose={handleDialogClose}>
              <DialogTitle sx={{backgroundColor:'#1B3C53',textAlign:'left',color:'white',fontSize:'1.5rem',fontFamily:'nunito'}}>
                Confirm Deletion <span>⚠️</span>
              </DialogTitle>
              <DialogContent sx={{textAlign:'left'}}>
                Are you sure you want to delete this topic?
              </DialogContent>
              <DialogActions sx={{ml:'50px'}}>
                <Button onClick={handleDialogClose} color="primary" sx={{ textAlign:'right !important', width:'50px !important', ml:'40px !important', '&:hover':{color:'green'}}}>
                  Cancel
                </Button>
                <Button onClick={handleConfirmDelete} color="error" sx={{ textAlign:'right !important', width:'50px !important', ml:'40px !important', '&:hover':{color:'red'}}}>
                  OK
                </Button>
              </DialogActions>
            </Dialog>
          </>
        )}
      </div>
    </Box>
  );
}

export default Topics;